// extracted by mini-css-extract-plugin
export default {"makeSentences":"MakeSentences_makeSentences__9pqy5","oneSentence":"MakeSentences_oneSentence__myghh","counter":"MakeSentences_counter__nws3I","clue":"MakeSentences_clue__mnHKN"};